import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Input, Select, Icon } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class MenuProductForm extends React.Component {
  constructor(props) {
    super(props);
    
    // Get categoryId from URL query params
    const query = new URLSearchParams(props.location.search);
    const categoryIdFromUrl = query.get('categoryId');
    
    this.state = {
      valid: false,
      loading: true,
      error: null,
      categories: [],
      categoryName: '',
      product_category_id: categoryIdFromUrl || '',
      name: '',
      price: '',
    };

    this.nameInputRef = React.createRef();
  }

  componentDidMount() {
    // Load all categories first
    this.loadCategories();
  }

  componentDidUpdate(prevProps, prevState) {
    // Focus the name input when loading is done
    if (prevState.loading && !this.state.loading) {
      if (this.nameInputRef.current) {
        this.nameInputRef.current.focus();
      }
    }
  }
  
  loadCategories = () => {
    API.getProductCategories()
      .then((response) => {
        const categories = response.data;
        this.setState({ 
          categories,
          loading: false
        }, () => {
          if (this.state.product_category_id) {
            this.loadCategoryName();
          }
          this.validate();
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ 
          error: 'Error al cargar las categorías',
          loading: false
        });
      });
  }
  
  loadCategoryName = () => {
    const categoryId = parseInt(this.state.product_category_id);
    const category = this.state.categories.find(cat => cat.id === categoryId);
    
    if (category) {
      this.setState({ 
        categoryName: category.name
      });
    } else {
      this.setState({ 
        error: 'No se encontró la categoría especificada'
      });
    }
  }

  handleCategoryChange = (e, { value }) => {
    this.setState({ product_category_id: value }, () => {
      this.loadCategoryName();
      this.validate();
    });
  }

  handleName = (event) => {
    this.setState({ name: event.target.value }, this.validate);
  }

  handlePrice = (event) => {
    const price = parseFloat(event.target.value);

    if (event.target.value === '') {
      this.setState({ price: '' }, this.validate);
    }

    if (!isNaN(price)) {
      this.setState({ price: event.target.value }, this.validate);
    }
  }
  
  validate = () => {
    let valid = true;
    if (!this.state.product_category_id) { valid = false; }
    if (this.state.name === '') { valid = false; }
    if (this.state.price === '') { valid = false; }
    if (isNaN(parseFloat(this.state.price))) { valid = false; }
    this.setState({ valid });
  }

  createProduct = () => {
    if (this.state.valid) {
      this.setState({ loading: true, error: null });
      
      const params = {
        product_category_id: this.state.product_category_id,
        name: this.state.name,
        price: this.state.price,
      };

      API.createProduct(params)
        .then((response) => {
          // Redirect to the newly created product page
          if (response.data && response.data.id) {
            this.props.history.push(`/menu/products/${response.data.id}`);
          } else {
            // Fallback to products list if we don't have the id
            this.props.history.push('/menu/products');
          }
        })
        .catch((error) => {
          console.error(error);
          this.setState({ 
            error: 'Error al crear el producto',
            loading: false
          });
        });
    }
  }

  render() {
    const formTitle = `Nuevo producto del menú`;
    
    if (this.state.loading) {
      return (
        <div>
          <Header text={formTitle} />
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando categorías...</p>
          </div>
        </div>
      );
    }
    
    const categoryOptions = this.state.categories.map(category => ({
      key: category.id,
      value: category.id,
      text: category.name
    }));
    
    return (
      <div>
        <Header text={formTitle} />
        
        {this.state.error && (
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            {this.state.error}
          </div>
        )}
        
        <Form as="div" style={{ marginTop: '1.5em' }}>
          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              CATEGORÍA
            </label>
            <Select
              placeholder='Seleccionar categoría'
              options={categoryOptions}
              value={this.state.product_category_id ? parseInt(this.state.product_category_id) : ''}
              onChange={this.handleCategoryChange}
              style={{ fontSize: '1.2em' }}
            />
          </Form.Field>
        
          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              NOMBRE
            </label>
            <Input
              ref={this.nameInputRef}
              value={this.state.name}
              onChange={this.handleName}
              placeholder="Nombre del producto"
              style={{ fontSize: '1.2em', height: '54px' }}
            />
          </Form.Field>

          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              PRECIO
            </label>
            <Input
              type="number"
              step="0.10"
              icon="dollar sign"
              iconPosition="left"
              value={this.state.price}
              onChange={this.handlePrice}
              placeholder="0.00"
              style={{ fontSize: '1.2em', height: '54px' }}
            />
          </Form.Field>
          
          <CancelGoButtons
            cancelFn={ () => this.props.history.push('/menu/products') }
            goText='crear producto'
            goFn={this.createProduct}
            goEnabled={this.state.valid && !this.state.loading}
            loading={this.state.loading}
            style={{
              button: {
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }
            }}
          />
        </Form>
      </div>
    )
  }
}

export default withRouter(MenuProductForm);